import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Sparkles, Heart } from "lucide-react";

interface SignupModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const SignupModal = ({ open, onOpenChange }: SignupModalProps) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent
      className="sm:max-w-md rounded-3xl border-border"
      onInteractOutside={(e) => e.preventDefault()}
    >
      <DialogHeader className="text-center space-y-3">
        <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-secondary to-purple flex items-center justify-center mx-auto">
          <Heart className="w-8 h-8 text-primary-foreground" />
        </div>
        <DialogTitle className="font-display text-2xl font-800 text-foreground">
          Keep your session going
        </DialogTitle>
        <DialogDescription className="text-muted-foreground text-base">
          You've used your free preview messages. Create an account to keep learning — it takes less than a minute.
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-3 pt-2">
        <Button
          className="w-full rounded-full bg-gradient-to-r from-primary to-secondary text-primary-foreground py-6 text-base shadow-lg hover:shadow-xl transition-all"
          asChild
        >
          <Link to="/auth">
            <Sparkles className="w-4 h-4 mr-2" />
            Create free account
          </Link>
        </Button>
        <Button
          variant="outline"
          className="w-full rounded-full py-6 text-base"
          asChild
        >
          <Link to="/auth">Already have an account? Sign in</Link>
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);

export default SignupModal;
